import React from "react";
import { Dialog } from "@mui/material";
import { makeStyles } from "@mui/styles";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import PatientsCreateAndEdit from "../../Components/Patients/PatientsCreateAndEdit";
// const PatientsCreateAndEdit = React.lazy(() =>
//   import("Components/Patients/PatientsCreateAndEdit")
// );

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      padding: "7.5px 108px 7.5px 6px !important",
    },
  },
  rsUpdateDialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      top: "0 !important",
    },
  },
}));

function PatientCreateDialog({
  open,
  setOpen,
  callBackOnSubmit,
  callBackOnCancel,
  createNewPatientFromCSV,
}) {
  const classes = useStyles();

  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };

  const callBackOfPatientFormSubmit = (responseData) => {
    handleClose();
    if (typeof callBackOnSubmit === "function") {
      callBackOnSubmit(responseData);
    }
  };

  const callBackOfPatientFormCancel = () => {
    handleClose();
    if (typeof callBackOnCancel === "function") {
      callBackOnCancel();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"lg"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={classes.rsUpdateDialog}
      >
        <PrimaryDialogTitle handleClose={handleClose} title="Import Patient" />
        <PatientsCreateAndEdit
          openImportCsvPatientForm={open}
          _pageAccessMode="importCsvPatient"
          callBackOnSubmit={callBackOfPatientFormSubmit}
          callBackOnCancel={callBackOfPatientFormCancel}
          createNewPatientFromCSV={createNewPatientFromCSV}
          dialog={true}
        />
      </Dialog>
    </>
  );
}

export default PatientCreateDialog;
